import React from 'react';
import TypeField from './components/TypeField/TypeField';
import DateTimeField from './components/DateTimeField/DateTimeField';
import TitleField from './components/TitleField/TitleField';
import UploadFilesField from './components/UploadFilesField/UploadFilesField';
import { HeaderImgField } from './components/HeaderImgField';
import InformationAboutAdvertisementText from './components/InformationAboutAdvertisementText/InformationAboutAdvertisementText';
import InnField from './components/InnField/InnField';
import PreviewFieldBtn from './components/PreviewFieldBtn/PreviewFieldBtn';

export const filedNames = {
  typeId: 'typeId',
  dateTime: 'dateTime',
  text: 'text',
  title: 'title',
  files: 'files',
};

export const editor = 'EDITOR';

export const fields = [
  {
    render: ({ form }) => <InformationAboutAdvertisementText form={form} />,
  },
  {
    render: ({ infoId }) => <HeaderImgField infoId={infoId} />,
  },
  {
    gutter: 8,
    children: [
      {
        span: 10,
        render: ({ form, initialValues }) => (
          <TypeField
            form={form}
            initialValue={initialValues[filedNames.typeId]}
          />
        ),
      },
      {
        span: 14,
        render: ({ form, initialValues }) => (
          <DateTimeField
            form={form}
            initialValue={initialValues[filedNames.dateTime]}
          />
        ),
      },
    ],
  },
  {
    render: ({ form, initialValues }) => (
      <TitleField
        form={form}
        initialValue={initialValues[filedNames.title]}
      />
    ),
  },
  {
    editor: editor,
  },
  {
    render: ({ form, handleChangeVisible }) => (
      <PreviewFieldBtn
        form={form}
        onChange={handleChangeVisible}
      />
    ),
  },
  {
    render: ({ form, initialValues }) => (
      <InnField
        form={form}
        initialValues={initialValues}
      />
    ),
  },
  {
    render: ({ form }) => <UploadFilesField form={form} />,
  },
];
